export default function ZAFilterIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={props.fill || "#6CB6E3"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.63027 6.49062C9.19503 6.08989 9.16869 5.41123 9.57027 4.97555L13.8577 0.328995C14.2622 -0.109367 15.0268 -0.109367 15.4312 0.328995L19.7153 4.97287C20.117 5.40846 20.0905 6.08708 19.6553 6.48794C19.4488 6.68257 19.1881 6.77632 18.9287 6.77632C18.64 6.77632 18.3524 6.66052 18.1422 6.43174L15.7147 3.79884V18.9273C15.7147 19.5165 15.2326 19.9986 14.6433 19.9986C14.0541 19.9986 13.572 19.5183 13.572 18.9264V3.79884L11.1449 6.43036C10.7463 6.8656 10.0677 6.89684 9.63027 6.49062ZM1.05943 13.508C1.49597 13.1031 2.17409 13.1324 2.57272 13.568L5.00113 16.1998V1.07225C5.00113 0.480324 5.47877 0 6.07248 0C6.66619 0 7.14384 0.480324 7.14384 1.07225V16.2007L9.5709 13.5692C9.78155 13.3404 10.0691 13.2246 10.3575 13.2246C10.6169 13.2246 10.878 13.3181 11.0842 13.5092C11.5194 13.9099 11.5458 14.5885 11.1442 15.0242L6.89894 19.6712C6.49442 20.1096 5.72983 20.1096 5.32539 19.6712L1.08015 15.0242C0.599644 14.5883 0.626429 13.9098 1.05943 13.508Z"
        fill="#6CB6E3"
      />
    </svg>
  )
}
